<template>
  <ul class="d-flex flex-row-reverse cursor p-0 align-items-center justify-content-center list-style-none">
    <li v-if="displayNextPage && displayLastPage" class="p-2 pagination-button cursor" @click="pagination(allPages)">
      <i class="fa-solid fa-chevrons-right"></i>
    </li>
    <li v-if="displayNextPage" class="p-2 pagination-button cursor" @click="pagination(currentPage+1)">
      <i class="fa-solid fa-chevron-right"></i>
    </li>
    <li v-if="displayNextPage || displayPreviousPage" class="p-2 cursor">
      <span class="px-3 py-2 pagination-button" v-for="previousPage in previousPages" :key="previousPage"
        @click="pagination(previousPage)">{{ previousPage }}</span>
      <span class="pagination-button-active">
        <!-- <input v-model="currentPage" @blur="pagination(newCurrentPage)" type="text" -->
          <!-- style="width:40px;text-align:center;"/> -->
          {{currentPage}}
      </span>
      <span class="px-3 py-2 pagination-button" v-for="nextPage in nextPages" :key="nextPage + currentPage"
        @click="pagination(nextPage + currentPage)">{{ nextPage + currentPage }}</span>
    </li>
    <li v-if="displayPreviousPage" class="p-2 pagination-button cursor" @click="pagination(currentPage-1)">
      <i class="fa-solid fa-chevron-left"></i>
    </li>
    <li v-if="displayPreviousPage && displayFirstPage" class="p-2 pagination-button cursor" @click="pagination(1)">
      <i class="fa-solid fa-chevrons-left"></i>
    </li>
  </ul>
</template>


<script>
/** @author ARO - TLV 2020
* @brief Component qui gère toutes les paginations sur MoneyRoad
* @param maxResultsByPage est le nombre de résultats maximum sur une page
* @param firstIndex correspond à l'indice de la première demande de la page sélectionnée
* @param nbResultsTotal correspond au total de résultats sur toutes les pages
* @param refreshEvent correspond à l'événement du bus à appeler lors d'un passage à une autre page
*/
export default {
  name: 'Pagination',
  props: ['maxResultsByPage', 'firstIndex', 'nbResultsTotal', 'refreshEvent'],
  data () {
    return {
      nbPage: 1,
      newCurrentPage: 1
    }
  },
  methods: {
    pagination (nb) {
      if (nb <= this.allPages && nb !== this.currentPage) {
        let newFirstIndex = (nb - 1) * this.maxResultsByPage + 1
        this.nbPage = nb
        this.$bus.$emit(this.refreshEvent, newFirstIndex)
      }
    }
  },
  /** @author TLV 02/04/2020
  * Remplacement du bus par des propriétés calculées pour gérer deux paginations sur une même page
  * (ce que ne permet pas vraiment le bus)
  * La page suivante est affichée si on n'est pas sur la dernière,
  * La page précédente est affichée sauf si on est sur la page 1 */
  computed: {
    displayLastPage () {
      return (this.currentPage + this.nextPages) < this.allPages
    },
    displayFirstPage () {
      return !this.previousPages.includes(1)
    },
    previousPages () {
      return Array.from(Array(this.currentPage).keys()).slice(Math.max(1, this.currentPage - 5))
    },
    nextPages () {
      return Math.min(5, this.allPages - this.currentPage)
    },
    allPages () {
      if (this.nbResultsTotal > this.maxResultsByPage) {
        return Math.floor(this.nbResultsTotal / this.maxResultsByPage) + ((this.nbResultsTotal % this.maxResultsByPage === 0) ? 0 : 1)
      } else if (Math.floor(this.nbResultsTotal / this.maxResultsByPage) + 1 === ((this.firstIndex - 1) / this.maxResultsByPage + 1)) {
        return 0
      } else {
        return this.currentPage
      }
    },
    currentPage: {
      get () {
        return (((this.firstIndex - 1) / this.maxResultsByPage) + 1)
      },
      set (newValue) {
        this.newCurrentPage = newValue
      }
    },
    /** @author ARO - TLV 2020
    * @brief Propriétée calculée qui vérifie si on affiche la page suivante ou non
    * @details Si le nombre de données affichées aux pages précédentes + le nombre
    *           max de données autorisées à être affichées sur cette page est
    *           toujours inférieur au nombre total de données retournées par la modé,
    *           alors on affiche le bouton pour passer à la page suivante
    */
    displayNextPage () {
      return (this.firstIndex + this.maxResultsByPage - 1 < this.nbResultsTotal)
    },
    displayPreviousPage () {
      return (this.firstIndex !== 1)
    }
  }
}
</script>

